import {GameRandom, Inject, ModelEvents, Singleton} from "@denishussar/html5-game-engine";
import {SendLetterModel} from "../Models/SendLetterModel";
import {LetterModel, LetterStateEnum} from "../Models/LetterModel";

@Singleton
export class SendLetterLogic {

    constructor(@Inject private _model: SendLetterModel,
                @Inject private _modelEvents: ModelEvents,
                @Inject private _random: GameRandom) {
    }

    public reset(): void {
        this._startPrint = false;
        this._model.letter = new LetterModel();
    }

    private _startPrint = false;

    public print(): void {
        this._startPrint = true;
        this._model.letter.visible = false;

        ++this._model.letter.state;

        this._model.letter.state === LetterStateEnum.full_text && this._modelEvents.dispatch(this._model, "allowSend");

    }

    public send(): void {
        this._modelEvents.dispatch(this._model, "win");
    }


    private _progress: number = 0;

    public update(frameRate: number): void {
        if (this._progress < 12 && !this._startPrint) {
            this._progress += frameRate;
            if ((Math.round(this._progress) % 2)) {
                this._model.letter.visible = true;
            } else {
                this._model.letter.visible = false;
            }

        }
    }
}
